import React from 'react';
import { AvatarCard } from 'components/AvatarCard';
import { useUploadElevePhoto } from 'queries/eleves/useUploadElevePhoto';

interface Props {
  onChange: (picture: string) => void;
  value?: string;
  readonly?: boolean;
}

export function Image(props: Props) {
  const { value } = props;
  const { upload: uploadElevePhoto, isUploading } = useUploadElevePhoto();
  const [picture, setPicture] = React.useState<string | undefined>(value);

  const onChange = props.readonly
    ? undefined
    : (p: string) => {
        setPicture(p);
        props.onChange(p);
      };
  return (
    <div>
      <AvatarCard
        isUploading={isUploading}
        onUpload={uploadElevePhoto}
        onChange={onChange}
        // C'est du 💩 il faut que je gère mieux ça...
        picture={picture === 'user' ? undefined : picture}
      />
    </div>
  );
}
